import * as SearchResults from '@elevio/kb-kit/lib/components/searchResults';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import { useSearchResults } from '@elevio/kb-kit/lib/hooks';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { MainCentered } from '../components/layouts/Main';
import PageLayout from '../components/layouts/Page';
import SearchMore from '../components/SearchMore';
import SearchResult from '../components/SearchResult';
const Page = () => {
    const { searchTerm, totalCount } = useSearchResults();
    return (<PageLayout header={<Header hideSearch>
          <div className="header-container"/>
        </Header>} searchCount={<div className="search-count">
          <SearchResults.IsNotEmpty>
            <p>
              <Trans i18nKey="search.count" count={totalCount || 0}>
                We found {{ count: totalCount }} articles for{' '}
                <strong>&quot;{{ searchTerm }}&quot;</strong>
              </Trans>
            </p>
          </SearchResults.IsNotEmpty>
        </div>} footer={<Footer />}>
      <MainCentered>
        <h1 className="visually-hidden">
          {searchTerm
            ? `Search results for "${searchTerm}"`
            : 'Search results'}
        </h1>
        <SearchResults.LoopResults>
          <SearchResult />
        </SearchResults.LoopResults>

        <SearchResults.IsEmpty>
          <div className="search-empty">
            <h2 className="search-empty-title">
              <Trans i18nKey="search.noResults">
                No results were found when searching for “
                <SearchResults.SearchTerm />
                ”. Please try another search term. For additional assistance,
                contact the City Clerk&apos;s Office during business hours at{' '}
                <a href="tel:%727-587-6710" target="_blank" rel="noreferrer">
                  727-587-6710
                </a>{' '}
                or email{' '}
                <a href="mailto:cityclerk@largo.com" target="_blank" rel="noreferrer">
                  cityclerk@largo.com
                </a>
                .
              </Trans>
            </h2>
            <p className="search-empty-message">
              <Trans i18nKey="search.tryAgain">
                Try another search or{' '}
                <a href="https://letusknowlargo.comcate.com/en">
                  Browse by category
                </a>
              </Trans>
            </p>
          </div>
        </SearchResults.IsEmpty>
        <SearchMore />
      </MainCentered>
    </PageLayout>);
};
export default Page;
